import { Pipe, PipeTransform } from '@angular/core';

import { BehaviorScreen } from '../models/view-models/monitor-models/screen.type';
import { ScreensStateService } from '../services/screen-state/screens-state.service';
import { ViewMode } from '../enums/view-mode.enum';

@Pipe({
  name: 'paginatorFilter',
  standalone: true
})
export class PaginatorFilterPipe implements PipeTransform {
  monInTheDashboard = this.screenStateService.monitorsInTheDashboard.value;

  constructor(
    private screenStateService: ScreensStateService
  ) {}

  transform(
    monitors: BehaviorScreen[],
    page: number,
    itemsPerPage: number,
    viewMode: ViewMode
  ): BehaviorScreen[] {

    if (!monitors || !monitors.length) {
      this.screenStateService.monitorsInTheDashboard.next([]);
      return [];
    }

    if (viewMode === ViewMode.Calendar || viewMode === ViewMode.FullScreen) {
      return monitors;
    }

    const startIndex = page * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const screensToShow = monitors.slice(startIndex, endIndex);
    const screensToDisconnect = this.monInTheDashboard.filter(screen => !screensToShow.includes(screen));

    this.screenStateService.disconnectScreens(screensToDisconnect);

    this.monInTheDashboard = screensToShow;

    this.screenStateService.connectScreens(screensToShow);
    this.screenStateService.monitorsInTheDashboard.next(screensToShow);
    return screensToShow;
  }
}
